






































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import UpdateWalletDetailsRequest from '@/models/Accounts/DepositAccounts/Wallets/UpdateWalletDetailsRequest';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import FieldLabel from '@/components/Shared/FieldLabel.vue';

@Component({ name: 'WalletDetailsEditDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    valid = true;
    dialog = false;
    updateSecondaryWalletRequest: UpdateWalletDetailsRequest = new UpdateWalletDetailsRequest(this.currentWallet);

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.updateSecondaryWalletRequest = new UpdateWalletDetailsRequest(this.currentWallet);
        }
    }

    get currentWallet() {
        return DepositAccountModule.currentDepositAccountWallet;
    }

    async save() {
        if (!this.valid) {
            return;
        }
        else {
            this.dialog = false;
            await DepositAccountModule.updateAccountWalletDetails(this.updateSecondaryWalletRequest);
        }
    }

}
